const initialState = {
  host: null,
  vulns: {
    isFetching: false,
    data: [],
    fields: {
      id: false,
      name: true,
      tags: true,
      date: true,
      status: true,
      confirmed: true,
      severity: true
    }
  },
  createOrEditService: {
    error: false,
    errorMessage: '',
    saved: false,
    selectedService: null
  },
  services: {
    isFetching: false,
    data: [],
    fields: {
      id: false,
      name: true,
      version: true,
      protocol: true,
      status: true,
      vulns: true,
      credentials: true,
      tags: true,
      port: true,
      owned: true
    }
  },
  tools: {
    isFetching: false,
    data: [],
    fields: {
      id: false,
      command: true,
      user: true,
      params: true,
      create_date: true
    }
  },
  vulnsGrouped: []
};

export default initialState;
